import { render, staticRenderFns } from "./ChartTable.vue?vue&type=template&id=67aa9248"
import script from "./ChartTable.vue?vue&type=script&lang=js"
export * from "./ChartTable.vue?vue&type=script&lang=js"
import style0 from "./ChartTable.vue?vue&type=style&index=0&id=67aa9248&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports